import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardTitle } from 'reactstrap';

export class SearchParamDisplay extends Component {
  constructor(props) {
    super(props);
    this.toggleExpand = this.toggleExpand.bind(this);
    this.state = {
      expanded: false,
    };
  }

  toggleExpand() {
    this.setState(state => ({
      expanded: !state.expanded,
    }));
  }

  render() {
    const { messages } = this.props;

    return (
      <div className="haz-search-params">

        <Card>
          <CardBody>
            <CardTitle tag="h1">Search Parameters</CardTitle>
            <div className="haz-search-param-values">
              {messages.map(message => <div className="haz-search-param-value" key={message}>{message}</div>)}
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

SearchParamDisplay.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
